import { z } from 'zod';
export const idParamSchema = z.object({ id: z.coerce.number().int().positive() });
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(50),
});
/** Trimmed, length-capped string (constitution §6.9). */
export const text = (min, max) => z.string().trim().min(min).max(max);
export const emailSchema = z.string().trim().toLowerCase().pipe(z.email().max(190));
/** Comma-separated list in a query string ("a,b") or a repeated array; empty means unset. */
export const csvList = (item, max = 10) => z.preprocess((v) => {
    if (v === undefined || v === '')
        return undefined;
    if (Array.isArray(v))
        return v;
    return String(v).split(',').filter(Boolean);
}, z.array(item).max(max).optional());
//# sourceMappingURL=common.js.map